import { createAppAsyncThunk } from "@/store/createAppAsyncThunk";
import { fetchAssigneesByEstateAsync } from "./assigneeListApi";

export const fetchAssigneesByEstateThunk = createAppAsyncThunk(
  "ticket/assignees/fetch",
  async (estateId: number) => {
    const response = await fetchAssigneesByEstateAsync(estateId);
    return response.data;
  },
);

// Derive Assignee type from API response
type AssigneesResponse = Awaited<
  ReturnType<typeof fetchAssigneesByEstateAsync>
>;
type AssigneesArray = AssigneesResponse["data"];
export type Assignee = NonNullable<AssigneesArray>[number];
